// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {SsoActionButtonDispatchProps, SsoActionButtonOwnProps, SsoActionButtonStateProps} from "../../components/sso/SsoActionButton";
import SsoActionButton from "../../components/sso/SsoActionButton";
import * as _ from "lodash";
import {ssoUserSendForgotPasswordAction} from "../../actions/sso/creators/ssoUserActionCreator";
import type {Caller} from "../../components/QueryPage";
import {extractCaller} from "../QueryPage";
import config from "../../config/config";
import {openSsoUserSendForgotPasswordEmailModalAction} from "../../actions/modal/creators/ssoUserSendForgotPasswordActionCreator";

const mapStateToProps = (state: StoreState, ownProps: SsoActionButtonOwnProps): SsoActionButtonStateProps => {

    const isLoading = _.get(state, `ssoUserAction.sendForgotPassword.${ownProps.ssoUid}.isLoading`, false);
    return {
        caller: extractCaller(state),
        disabled: isLoading,
        isLoading,
        roleIds: state.loginUser.roleIds
    };
};

const mapDispatchToProps = (dispatch): SsoActionButtonDispatchProps => {
    return {
        onClickAction: (ssoUid: string, caller: Caller, roleIds: Array<string>) => {
            if (!_.includes(roleIds, config.superUserRole)) {

                dispatch(openSsoUserSendForgotPasswordEmailModalAction(ssoUid));
            } else {
                dispatch(ssoUserSendForgotPasswordAction(ssoUid, caller));
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SsoActionButton);



// WEBPACK FOOTER //
// ./src/containers/sso/SendForgotPasswordEmailButton.js